<template>
  <div class="modalStatisticsForMonth">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">月度统计</div>
        <div style="folat:right">
          <el-button type="danger" @click="closeSelf">关闭</el-button>
        </div>
      </div>
      <div class="modal-body" :style="bodyStyle">
        <el-row style="margin-top:20px">
          <el-col :span="24">
            <el-table
                :data="tableData"
                v-loading="loading"
                style="width: 100%" border :height="th">

              <el-table-column prop="remarks" label="统计范围"></el-table-column>

              <el-table-column v-for="(item ,index) in  censusElderlyClassItemList" :key="index" :label="item.elderlyClassName" >
                <template slot-scope="scope">
                  <span>{{scope.row.censusElderlyClassItemList[index].total}}</span>
                </template>
              </el-table-column>


            </el-table>


            <div style="text-align: left;background-color: #fff;padding: 10px;">
              <div style="float: left;padding: 5px;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
              <div style="float: left;">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalItems"
                    :page-size="20"
                    :current-page.sync="currentPage"  @current-change="current_change">
                </el-pagination>
              </div>
              <div style="clear: both;"></div>
            </div>
          </el-col>
        </el-row>


      </div>
    </div>


  </div>
</template>

<script>
import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "RechargeInfo",
  data() {
    return {
      censusElderlyClassItemList:[],
      loading:false,
      tableData:null,
      pageSize: 20,
      currentPage: 1,
      totalItems:0,
      bodyStyle:"height:"+(this.$store.state.tableHeight+150)+'px',
      th:this.$store.state.tableHeight,
    }
  },
  watch:{

  },
  components: {},
  created() {

  },
  methods: {
    init() {
      this.getBatchRechargeInfo();
    },
    closeSelf(){
      this.$emit("closeStatisticsForMonth");
    },
    getTime(row) {
      return timefilters(row.createTime)
    },
    getBatchRechargeInfo() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/PageForStatistics",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.tableData = response.data.data.list;
              this.totalItems = response.data.data.total;
              this.censusElderlyClassItemList=response.data.data.list[0].censusElderlyClassItemList;
              console.log("1-----")
              console.log(this.censusElderlyClassItemList)
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },


    current_change: function (currentPage) {
      this.searchForm.pageIndex = currentPage;
      this.getElderly();
    },
  }
}


</script>

<style lang="scss" scoped>

.modalStatisticsForMonth {
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 200px;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: none;
    border-radius: 0;
    width: 100%;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px 20px 0;
      z-index: 99;
    }

    .modal-body /deep/ .el-card.is-always-shadow {
      box-shadow: none;
      border-bottom: none;
      margin-bottom: 20px;
    }

    // .modal-footer {
    //   border-top: 1px solid #eee;
    //   justify-content: center;
    //   padding: 15px;
    //   display: flex;

    //   .el-button {
    //     width: 15%;
    //   }
    // }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}


</style>